<template>
    <div class="col-12 row form-group">
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Template Name</label>
            <input  class="form-control" id="template_name" type="text" v-model="template_name"/>
        </div>
        <div class="col-6">
        <label class="my-0 mt-2" for="input-live">Folder</label>
            <v-select id="folder" label="name" :multiple="true" v-model="folder" :options="folderList"></v-select>
        </div>
    </div>
</template>

<script>
    import { requestService } from '../../../_services';
    export default {
        components: {
        },
        props: {
        filterTab: Number,
        module:String
        },
        data() {
            return {
                template_name: '',
                folder:[],
                folderList:[],
            };
        },

        watch: {
        // whenever question changes, this function will run
        filterTab(newValue, oldValue) {
            let myFilter = JSON.parse(localStorage.getItem('filter-report-case'));
            if (newValue == 1) {
            this.dateStart = myFilter.dateStart;
            this.dateEnd = myFilter.dateEnd;
            
            } else {
            this.dateStart = '';
            this.dateEnd = '';
            }
        },
        },
        async mounted() {
            this.getFolder()
        },
        methods: {
            async getFolder() {
                let url = `/api/mail/folder/all`;
                const resFolder = await requestService.GetFetch('ccp', url);
                const folder = await resFolder.json();
                this.folderList = folder.data;
            },
            getFilter() {
                var folderArr=[]
                this.folder.forEach(element => {
                    folderArr.push(element._id)
                });
                let object = {
                    folder_id:folderArr.join(","),
                    template_name:this.template_name,
                };
                return object;
            },
            inputHandler(eventData) {
                console.log(eventData);
            },
      
    },
  };
</script>

<style></style>
